import { Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircle } from "../../../../../../../components/mobile/TeamIconCircle";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../../../../../components/atoms/ListSectionHeader";
import { ListSectionHeaderTeam_Team$key } from "./__generated__/ListSectionHeaderTeam_Team.graphql";

export function ListSectionHeaderTeam(props: {
  team: ListSectionHeaderTeam_Team$key;
}) {
  const data = useFragment(
    graphql`
      fragment ListSectionHeaderTeam_Team on Team {
        name
        ...TeamIconCircleComponent_Team
      }
    `,
    props.team
  );

  return (
    <ListSectionHeader>
      <TeamIconCircle team={data} size="smallMedium" />
      <Box spaceRight="small" />
      <ListSectionHeaderTitle>{data.name}</ListSectionHeaderTitle>
    </ListSectionHeader>
  );
}
